/* Restore the theme quantity field and bridge it to the native Xboost tiers. No discount values are modified. */
(()=>{
 if(window.ebrosiaQuantityBridge)return;window.ebrosiaQuantityBridge=true;
 const inputSelector='.product-info quantity-selector input[data-eb-qb-quantity]';
 let desired=null,internalClick=false,queued=false;
 const input=()=>document.querySelector(inputSelector);
 const root=()=>document.querySelector('.product-info #xb-quantity-breaks-root');
 const enabled=()=>!!(input()&&root()?.querySelector('.xb_quantity_list_item'));
 const clamp=(value,el)=>{let min=Math.max(1,Number(el.min)||1),step=Math.max(1,Number(el.step)||1),max=Number(el.max)||Infinity,q=Number(value);if(!Number.isFinite(q))q=min;q=Math.max(min,Math.min(max,Math.round(q)));return min+Math.floor((q-min)/step)*step;};
 function write(value){
  if(!enabled())return;
  const el=input(),q=clamp(value,el),selector=el.closest('quantity-selector');
  if(el.hasAttribute('name'))el.removeAttribute('name'); // Xboost owns the form's sole quantity input.
  if(el.value!==String(q)){el.value=String(q);el.dispatchEvent(new Event('input',{bubbles:true}));}
  selector.querySelector('button:first-of-type').disabled=q<=Math.max(1,Number(el.min)||1);
  selector.querySelector('button:last-of-type').disabled=!!el.max&&q>=Number(el.max);
  el.parentElement.style.setProperty('--quantity-selector-character-count',Math.max(1,String(q).length)+'ch');
  const form=el.form;
  if(form)form.querySelectorAll('input[name="quantity"].xb-upsell-input').forEach(hidden=>{hidden.value=String(q);});
 }
 function sync(){if(!enabled())return;write(desired??window.xb_qb_current_quantity??1);}
 function schedule(){if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;sync();});}
 function request(value){
  if(!enabled())return;
  desired=clamp(value,input());
  const tiers=window.quantity_break_data?.data_settings?.offer?.discounts?.quantity_breaks||window.xb_qb_data?.a_setting?.offer?.discounts?.quantity_breaks;
  const rows=[...root().querySelectorAll('.xb_quantity_list_item')];
  if(Array.isArray(tiers)&&tiers.length===rows.length){
   let index=0;tiers.forEach((tier,i)=>{if(Number(tier.quantity)<=desired)index=i;});
   if(!rows[index].querySelector('input[type="radio"]')?.checked){internalClick=true;try{rows[index].click();}finally{internalClick=false;}}
  }
  write(desired);schedule();
 }
 document.addEventListener('change',event=>{if(event.target.matches?.(inputSelector))request(event.target.value);});
 document.addEventListener('click',event=>{if(event.target.closest?.('.product-info #xb-quantity-breaks-root .xb_quantity_list_item')&&!internalClick){desired=null;schedule();}},true);
 document.addEventListener('xboost-upsell-qb-quantity-change',event=>{if(!enabled())return;write(desired??event.detail?.quantity??1);schedule();});
 document.addEventListener('variant:change',()=>{desired=null;schedule();});
 document.addEventListener('submit',event=>{if(enabled()&&event.target===input().form)request(input().value);},true);
 document.addEventListener('formdata',event=>{if(enabled()&&event.target===input().form)event.formData.set('quantity',String(clamp(desired??input().value,input())));},true);
 const start=()=>{const observer=new MutationObserver(schedule);observer.observe(document.querySelector('main')||document.body,{childList:true,subtree:true});sync();};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
